import type {CreateExtArgs} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import type {StructureExtensionAPI} from '../../structure'
import type {ComponentDefinitionExtensionAPI} from '../../componentDefinition'

type ComponentCallback = (compPointer: Pointer, componentType: string) => void

export const traverseComponents = (
    createExtArgs: CreateExtArgs,
    containerPointer: Pointer,
    onComponent: ComponentCallback
): void => {
    const {extensionAPI} = createExtArgs
    const {components} = extensionAPI as StructureExtensionAPI
    const {componentDefinition} = extensionAPI as ComponentDefinitionExtensionAPI

    const traverse = (compPointer: Pointer): void => {
        try {
            const type = components.getComponentType(compPointer)
            if (!type) {
                return
            }

            onComponent(compPointer, type)

            if (componentDefinition.isContainer(type)) {
                try {
                    const children = components.getChildren(compPointer, true)
                    for (const childPointer of children) {
                        traverse(childPointer)
                    }
                } catch {
                    // Skip components with invalid children
                }
            }
        } catch {
            // Skip component if extraction fails
            return
        }
    }

    traverse(containerPointer)
}
